// extracted by mini-css-extract-plugin
export default {"breadcrumb":"styles_breadcrumb__nB8Z7","breadcrumb-item":"styles_breadcrumb-item__9X9Bc","active":"styles_active__T-DfI"};